import { FetchStatus } from '@flatsy/types/FetchStatus'
import { unwrapResult } from '@reduxjs/toolkit'
import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchAsset } from 'src/redux/slices/Assets'
import { selectAsset } from 'src/redux/slices/Assets/Selector'
import { AppDispatch } from 'src/utils/AppDispatch'
import { HookReturn } from './Type'

export const useAsset = (assetURLId: string): HookReturn => {
  const dispatch: AppDispatch = useDispatch()
  const assetState = useSelector(selectAsset)
  const { asset } = assetState
  const requestStatus = assetState.status

  /**
   * @description fetch public asset by url_id
   */
  const fetchAssetEvent = async () => {
    try {
      const action = await dispatch(
        fetchAsset({
          id: assetURLId,
        })
      )
      unwrapResult(action)
    } catch (err) {
      //
    }
  }

  const assetCallBack = useCallback(() => fetchAssetEvent(), [assetURLId])

  useEffect(() => {
    if (assetURLId && assetURLId !== '' && !asset && requestStatus !== FetchStatus.LOADING) {
      assetCallBack()
    }
  }, [dispatch, assetURLId, asset])

  return { asset, requestStatus }
}

export const useSelectAsset = (): HookReturn => {
  const assetState = useSelector(selectAsset)
  const { asset } = assetState
  const requestStatus = assetState.status

  return { asset, requestStatus }
}
